import { InfoOutlined } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

const AiScreeningOptimizedAlert: React.FC = () => {
  const { formatMessage } = useIntl()

  return (
    <Stack bgcolor="info.light" p={2} direction="row" spacing={1.5} borderRadius={2}>
      <InfoOutlined />
      <Stack>
        <Typography variant="subtitle1">
          {formatMessage({ id: 'aiScreening.infoPage.optimizedSettingsTitle' })}
        </Typography>
        <Typography variant="body2">
          {formatMessage({ id: 'aiScreening.infoPage.optimizedSettingsDescription' })}
        </Typography>
      </Stack>
    </Stack>
  )
}

export default AiScreeningOptimizedAlert
